<template>
  <div class="auth-page">
    <div class="auth-shell">
      <aside class="auth-brand">
        <div class="brand-mark">永</div>
        <div class="brand-kicker">长生修真世界</div>
        <h1>永诀</h1>
        <p>登录道友身份，继续你的修行旅程。</p>
        <div class="brand-line"></div>
        <span>山海万象 · 一念入道</span>
      </aside>

      <main class="auth-panel">
        <transition name="auth-switch" mode="out-in">
          <!-- 登录页面 -->
          <section v-if="cut" key="login" class="auth-content">
            <div class="title-section">
              <span class="eyebrow">WELCOME BACK</span>
              <h2 class="page-title">欢迎回来</h2>
              <div class="subtitle">登录后选择角色，进入修真世界</div>
            </div>

            <form class="auth-form" @submit.prevent="enroll">
              <div class="field">
                <label class="field-label" for="login-username">账号</label>
                <Input
                    id="login-username"
                    placeholder="请输入6~20位的账号"
                    v-model="formlogin.username"
                    class="auth-input"
                    prefix="ios-contact"
                    @keyup="checkCapsLock"
                    autocomplete="username"
                    maxlength="20"
                />
              </div>
              <div class="field">
                <label class="field-label" for="login-password">密码</label>
                <div class="password-input-wrapper">
                    <Input
                      id="login-password"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="请输入6~20位的密码"
                      v-model="formlogin.password"
                      class="auth-input password-input"
                      prefix="ios-lock"
                      @keyup="checkCapsLock"
                      @blur="capsLockWarning = false"
                      autocomplete="current-password"
                      maxlength="20"
                    />
                    <button
                      type="button"
                      class="password-toggle"
                      @click="showPassword = !showPassword"
                      :aria-label="showPassword ? '隐藏密码' : '显示密码'"
                      :title="showPassword ? '隐藏密码' : '显示密码'"
                    >
                      <Icon :type="showPassword ? 'ios-eye-off' : 'ios-eye'" />
                    </button>
                </div>
              </div>
              <div v-if="capsLockWarning" class="capslock-warning">
                <Icon type="ios-warning" />
                <span>大写锁定已开启</span>
              </div>
              <button type="submit" class="auth-submit" :disabled="loggingIn">
                <span v-if="loggingIn" class="button-spinner"></span>
                {{ loggingIn ? "登录中..." : "登录" }}
              </button>
            </form>
          </section>

          <!-- 注册页面 -->
          <section v-else key="register" class="auth-content">
            <div class="title-section">
              <span class="eyebrow">CREATE ACCOUNT</span>
              <h2 class="page-title">创建账号</h2>
              <div class="subtitle">登记仙籍，开启你的修行旅程</div>
            </div>

            <form class="auth-form" @submit.prevent="register">
              <div class="field">
                <label class="field-label" for="register-username">账号</label>
                <Input
                    id="register-username"
                    placeholder="请输入6~20位的账号"
                    v-model="formRegister.username"
                    class="auth-input"
                    prefix="ios-contact"
                    @keyup="checkCapsLock"
                    autocomplete="username"
                    maxlength="20"
                />
              </div>
              <div class="field">
                <label class="field-label" for="register-nickname">昵称</label>
                <Input
                    id="register-nickname"
                    placeholder="请输入1~12位的昵称"
                    v-model="formRegister.nickname"
                    class="auth-input"
                    prefix="ios-person"
                    autocomplete="nickname"
                    maxlength="12"
                />
              </div>
              <div class="field">
                <label class="field-label" for="register-password">密码</label>
                <div class="password-input-wrapper">
                    <Input
                      id="register-password"
                      :type="showRegisterPassword ? 'text' : 'password'"
                      placeholder="请输入6~20位的密码"
                      v-model="formRegister.password"
                      class="auth-input password-input"
                      prefix="ios-lock"
                      @keyup="checkCapsLock"
                      @blur="registerCapsLockWarning = false"
                      autocomplete="new-password"
                      maxlength="20"
                    />
                    <button
                      type="button"
                      class="password-toggle"
                      @click="showRegisterPassword = !showRegisterPassword"
                      :aria-label="showRegisterPassword ? '隐藏密码' : '显示密码'"
                      :title="showRegisterPassword ? '隐藏密码' : '显示密码'"
                    >
                      <Icon :type="showRegisterPassword ? 'ios-eye-off' : 'ios-eye'" />
                    </button>
                </div>
              </div>
              <div class="field">
                <label class="field-label" for="register-confirm-password">确认密码</label>
                <div class="password-input-wrapper">
                    <Input
                      id="register-confirm-password"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      placeholder="请再输入一次密码"
                      v-model="formRegister.confirmPassword"
                      class="auth-input password-input"
                      prefix="ios-lock"
                      @keyup="checkCapsLock"
                      @blur="confirmCapsLockWarning = false"
                      autocomplete="new-password"
                      maxlength="20"
                    />
                    <button
                      type="button"
                      class="password-toggle"
                      @click="showConfirmPassword = !showConfirmPassword"
                      :aria-label="showConfirmPassword ? '隐藏密码' : '显示密码'"
                      :title="showConfirmPassword ? '隐藏密码' : '显示密码'"
                    >
                      <Icon :type="showConfirmPassword ? 'ios-eye-off' : 'ios-eye'" />
                    </button>
                </div>
              </div>
              <div v-if="registerCapsLockWarning || confirmCapsLockWarning" class="capslock-warning">
                <Icon type="ios-warning" />
                <span>大写锁定已开启</span>
              </div>
              <button type="submit" class="auth-submit" :disabled="registering">
                <span v-if="registering" class="button-spinner"></span>
                {{ registering ? "注册中..." : "注册" }}
              </button>
            </form>
          </section>
        </transition>

        <div class="switch-mode">
          <span class="divider"></span>
          <span class="switch-text">
            {{ cut ? "还没有账号？" : "已有账号？" }}
            <button type="button" class="switch-link" @click="switchMode">
              {{ cut ? "立即注册" : "返回登录" }}
            </button>
          </span>
          <span class="divider"></span>
        </div>
      </main>
    </div>

    <!-- 全局键盘事件监听 -->
    <div
      v-if="globalCapsLockWarning"
      class="global-capslock-warning"
      @click="globalCapsLockWarning = false"
    >
      <div class="warning-content">
        <Icon type="ios-warning" class="global-warning-icon" />
        <span>大写锁定已开启</span>
        <Icon type="ios-close" class="close-icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
      return {
          cut: true,
          selectChara: false,
          showPassword: false,
          showRegisterPassword: false,
          showConfirmPassword: false,
          capsLockWarning: false,
          registerCapsLockWarning: false,
          confirmCapsLockWarning: false,
          globalCapsLockWarning: false,
          capsLockActive: false,
          loggingIn: false,
          registering: false,
          ruleValidate: {
              username: [
                  { required: true, message: "请输入用户名", trigger: "blur" },
              ],
              password: [
                  { required: true, message: "请输入密码", trigger: "blur" },
                  {
                      type: "string",
                      min: 6,
                      message: "请输入6位数以上的密码",
                      trigger: "blur",
                  },
              ],
          },
          formRegister: {
              username: undefined,
              password: undefined,
              nickname: undefined,
              confirmPassword: undefined,
          },
          formlogin: {
              username: undefined,
              password: undefined,
              confirmPassword: undefined,
          },
      };
  },
  mounted() {
      window.addEventListener('keydown', this.handleGlobalKeyDown);
      window.addEventListener('keyup', this.handleGlobalKeyUp);
      //this.detectInitialCapsLock();
  },
  beforeDestroy() {
      window.removeEventListener('keydown', this.handleGlobalKeyDown);
      window.removeEventListener('keyup', this.handleGlobalKeyUp);
  },
  methods: {
      switchMode() {
          this.cut = !this.cut;
          this.capsLockWarning = false;
          this.registerCapsLockWarning = false;
          this.confirmCapsLockWarning = false;
          this.globalCapsLockWarning = false;
      },

      getErrorMessage(err, fallback) {
          const responseData = err && err.response && err.response.data;
          if (responseData && responseData.msg) return responseData.msg;
          if (err && err.data && err.data.msg) return err.data.msg;
          return fallback;
      },

      validateLogin() {
          const username = String(this.formlogin.username || '').trim();
          const password = String(this.formlogin.password || '');
          this.formlogin.username = username;

          if (!username) {
              this.$Notice.warning({title: "请输入账号"});
              return false;
          }
          if (username.length < 4 || username.length > 20) {
              this.$Notice.warning({title: "账号需要为4~20位"});
              return false;
          }
          if (!password) {
              this.$Notice.warning({title: "请输入密码"});
              return false;
          }
          if (password.length < 6 || password.length > 20) {
              this.$Notice.warning({title: "密码需要为6~20位"});
              return false;
          }
          return true;
      },

      validateRegister() {
          const username = String(this.formRegister.username || '').trim();
          const nickname = String(this.formRegister.nickname || '').trim();
          const password = String(this.formRegister.password || '');
          const confirmPassword = String(this.formRegister.confirmPassword || '');
          this.formRegister.username = username;
          this.formRegister.nickname = nickname;

          if (!username) {
              this.$Notice.warning({title: "请输入账号"});
              return false;
          }
          if (username.length < 6 || username.length > 20) {
              this.$Notice.warning({title: "账号需要为6~20位"});
              return false;
          }
          if (!nickname) {
              this.$Notice.warning({title: "请输入昵称"});
              return false;
          }
          if (Array.from(nickname).length > 12) {
              this.$Notice.warning({title: "昵称不能超过12位"});
              return false;
          }
          if (password.length < 6 || password.length > 20) {
              this.$Notice.warning({title: "密码需要为6~20位"});
              return false;
          }
          if (password !== confirmPassword) {
              this.$Notice.warning({title: "两次输入密码不同"});
              return false;
          }
          return true;
      },

      detectInitialCapsLock() {
          const input = document.createElement('input');
          input.type = 'password';
          document.body.appendChild(input);
          input.focus();

          const checkCapsLock = (e) => {
              const key = e.key;
              const shiftKey = e.shiftKey;

              if (key.length === 1 && /[A-Za-z]/.test(key)) {
                  this.capsLockActive = (key === key.toUpperCase() && !shiftKey) ||
                                       (key === key.toLowerCase() && shiftKey);
              }

              input.removeEventListener('keypress', checkCapsLock);
              document.body.removeChild(input);
          };

          input.addEventListener('keypress', checkCapsLock);
      },

      checkCapsLock(event) {
          const key = event.key;
          const shiftKey = event.shiftKey;

          if (key && key.length === 1 && /[A-Za-z]/.test(key)) {
              const capsLockOn = (key === key.toUpperCase() && !shiftKey) ||
                                (key === key.toLowerCase() && shiftKey);

              this.capsLockActive = capsLockOn;

              if (capsLockOn) {
                  const inputName = event.target.getAttribute('placeholder');

                  if (inputName && inputName.includes('密码')) {
                      if (this.cut) {
                          this.capsLockWarning = true;
                      } else {
                          if (event.target.placeholder.includes('请再输入一次')) {
                              this.confirmCapsLockWarning = true;
                          } else {
                              this.registerCapsLockWarning = true;
                          }
                      }

                      this.showGlobalCapsLockWarning();
                  }
              } else {
                  this.capsLockWarning = false;
                  this.registerCapsLockWarning = false;
                  this.confirmCapsLockWarning = false;
              }
          }

          if (key === 'CapsLock') {
              this.capsLockActive = !this.capsLockActive;
              this.updateCapsLockWarnings();
          }
      },

      handleGlobalKeyDown(event) {
          if (event.key === 'CapsLock') {
              this.capsLockActive = !this.capsLockActive;
              this.updateCapsLockWarnings();
          }
      },

      handleGlobalKeyUp(event) {
          if (event.key === 'CapsLock') {
              this.updateCapsLockWarnings();
          }
      },

      updateCapsLockWarnings() {
          if (this.capsLockActive) {
              this.showGlobalCapsLockWarning();

              if (this.cut && this.formlogin.password) {
                  this.capsLockWarning = true;
              } else if (!this.cut) {
                  if (this.formRegister.password) {
                      this.registerCapsLockWarning = true;
                  }
                  if (this.formRegister.confirmPassword) {
                      this.confirmCapsLockWarning = true;
                  }
              }
          } else {
              this.capsLockWarning = false;
              this.registerCapsLockWarning = false;
              this.confirmCapsLockWarning = false;
              this.globalCapsLockWarning = false;
          }
      },

      showGlobalCapsLockWarning() {
          this.globalCapsLockWarning = true;
          setTimeout(() => {
              this.globalCapsLockWarning = false;
          }, 3000);
      },

      enroll() {
          if (this.loggingIn) return;
          if (!this.validateLogin()) return;
          this.loggingIn = true;
          this.$http.post("gamepassport/login", this.formlogin).then((res) => {
              if (res.data.msg != "OK") {
                  this.$Notice.warning({title:res.data.msg});
                  return;
              }
              if (res.data.data.userId) {
                  this.$Notice.success({title:"登录成功"});
                  sessionStorage.setItem("user",JSON.stringify(res.data.data));
                  this.setCookie("token", res.data.data.token, 3);
                  this.setCookie("userId", res.data.data.userId, 3);
                  localStorage.setItem("username", res.data.data.name)
                  localStorage.setItem("token", res.data.data.token)
                  localStorage.setItem("userId", res.data.data.userId)
                  document.cookie = "token=" + res.data.data.token + ";userId=" + res.data.data.userId ;
                  this.$router.push({ name: "selectChara" });
              }
          }).catch((err) => {
              this.$Notice.warning({title: this.getErrorMessage(err, "登录失败")});
          }).finally(() => {
              this.loggingIn = false;
          });
      },
      register() {
          if (this.registering) return;
          if (!this.validateRegister()) return;

          this.registering = true;
          this.$http.post("gamepassport/regist", this.formRegister).then((res) => {
              if (res.data.msg != "ok") {
                  this.$Notice.warning({title:res.data.msg});
                  return;
              }
              this.$Notice.success({title:"注册成功，请登录"});
              this.formlogin.username = this.formRegister.username;
              this.formlogin.password = this.formRegister.password;
              this.cut = true;
          }).catch((err) => {
              this.$Notice.warning({title: this.getErrorMessage(err, "注册失败")});
          }).finally(() => {
              this.registering = false;
          });
      },
      setCookie(name, value, days) {
          let expires = "";
          if (days) {
              let date = new Date();
              date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
              expires = "; expires=" + date.toUTCString();
          }
          document.cookie = name + "=" + (value || "") + expires + "; path=/";
      }
  },
};
</script>

<style scoped>
.hello {
  height: var(--app-height);
  background-image: url('../assets/loginPageDefBg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
  overflow: hidden;
}

/* 白蓝主题色 */
:root {
  --primary-color: #c8d7e2;
  --secondary-color: #2c3e50;
  --accent-color: #1abc9c;
  --light-color: #ecf0f1;
  --white-color: #ffffff;
  --gray-light: #f8f9fa;
  --gray-border: #e9ecef;
  --text-primary: #2c3e50;
  --text-secondary: #7f8c8d;
}


/* 修真装饰元素 - 调整为蓝白色调 */
.decoration {
  position: absolute;
  z-index: 1;
}

.taoist-symbol {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #3498db, #2c3e50);
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  opacity: 0.15;
  top: 20px;
  left: 20px;
  animation: float 6s ease-in-out infinite;
}

.cloud {
  width: 80px;
  height: 30px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  filter: blur(2px);
}

.cloud-1 {
  top: 30%;
  left: 10%;
  animation: float 8s ease-in-out infinite;
}

.cloud-2 {
  top: 60%;
  right: 15%;
  animation: float 10s ease-in-out infinite reverse;
}

.cloud-3 {
  top: 25%;
  right: 10%;
  animation: float 9s ease-in-out infinite;
}

.cloud-4 {
  top: 65%;
  left: 12%;
  animation: float 7s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% { transform: translateY(0) translateX(0); }
  50% { transform: translateY(-10px) translateX(5px); }
}

.record {
  width: 420px;
  min-height: 420px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(248, 249, 250, 0.97));
  backdrop-filter: blur(10px);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.9);
  padding: 10px;
  z-index: 2;
}

.record::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  overflow: hidden;
  border-radius: 18px;
  z-index: -1;
  opacity: 0.08;
  filter: blur(2px);
}

.title-section {
  text-align: center;
  padding-top: 30px;
  margin-bottom: 10px;
}

.page-title {
  color: var(--secondary-color);
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
  letter-spacing: 2px;
  position: relative;
  display: inline-block;
}

.page-title::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 25%;
  width: 50%;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--primary-color), transparent);
}

.subtitle {
  color: var(--primary-color);
  font-size: 14px;
  opacity: 0.8;
  letter-spacing: 1px;
}

.login-form,
.register-form {
  margin-top: 25px;
  margin-left: 24px;
  width: 80%;
}

.form-item {
  margin-bottom: 18px !important;
}

.form-item >>> .ivu-form-item-label {
  color: var(--secondary-color) !important;
  font-weight: bold;
  font-size: 14px;
  padding-right: 12px;
}

.custom-input {
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid var(--gray-border) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  color: var(--text-primary) !important;
  height: 36px;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.custom-input:hover {
  border-color: var(--primary-color) !important;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.1) !important;
}

.custom-input:focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2) !important;
}

.custom-input >>> .ivu-input-prefix i {
  color: var(--primary-color) !important;
}

/* 密码输入框包装器 */
.password-input-wrapper {
  position: relative;
  width: 100%;
}

.password-input {
  padding-right: 40px !important;
}

/* 独立的眼睛图标容器 */
.eye-icon-container {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.eye-icon-container:hover {
  background: white;
  box-shadow: 0 2px 6px rgba(52, 152, 219, 0.3);
}

.eye-icon-container:active {
  transform: translateY(-50%) scale(0.95);
}

.eye-icon {
  color: var(--primary-color) !important;
  font-size: 18px !important;
  transition: all 0.3s ease;
}

.eye-icon-container:hover .eye-icon {
  color: var(--accent-color) !important;
}

/* 大写锁定警告样式 */
.capslock-warning {
  display: flex;
  align-items: center;
  margin-top: 6px;
  padding: 6px 10px;
  background: linear-gradient(135deg, rgba(255, 243, 224, 0.9), rgba(255, 236, 210, 0.9));
  border: 1px solid #ffb347;
  border-radius: 6px;
  color: #d35400;
  font-size: 12px;
  animation: pulse 2s infinite;
}

.warning-icon {
  margin-right: 6px;
  color: #ff6b35;
  font-size: 14px;
}

/* 全局大写锁定警告 */
.global-capslock-warning {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  cursor: pointer;
  animation: slideIn 0.3s ease-out;
}

.warning-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(135deg, rgba(255, 243, 224, 0.95), rgba(255, 236, 210, 0.95));
  border: 2px solid #ffb347;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: #d35400;
  font-weight: bold;
  min-width: 180px;
}

.global-warning-icon {
  margin-right: 10px;
  color: #ff6b35;
  font-size: 20px;
}

.close-icon {
  margin-left: 10px;
  color: #d35400;
  font-size: 18px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.close-icon:hover {
  opacity: 1;
}

/* 登录按钮样式 */
.login-button {
  width: 74%;
  margin: 20px 13% 0;
  --button_radius: 8px;
  --button_color: linear-gradient(135deg, #ffffff, #f8f9fa);
  --button_outline_color: var(--primary-color);
  font-size: 16px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  border-radius: var(--button_radius);
  background: var(--button_outline_color);
  transition: all 0.3s;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(52, 152, 219, 0.3);
}
.button_top {
  display: block;
  box-sizing: border-box;
  border: 2px solid var(--button_outline_color);
  border-radius: var(--button_radius);
  padding: 0.75em 1.5em;
  background: var(--button_color);
  color: var(--button_outline_color);
  transform: translateY(-0.2em);
  transition: transform 0.1s ease;
}
.login-button:hover .button_top {
  transform: translateY(-0.33em);
  background: linear-gradient(135deg, #ffffff, #f1f8ff);
}

.login-button:active .button_top {
  transform: translateY(0);
}

/* 注册按钮样式 */
.register-button {
  width: 74%;
  margin: 20px 13% 0;
  background: linear-gradient(135deg, var(--primary-color), #2980b9) !important;
  border: none !important;
  border-radius: 8px !important;
  height: 44px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  transition: all 0.3s !important;
  box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3) !important;
  color: white !important;
}

.register-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(52, 152, 219, 0.4) !important;
  background: linear-gradient(135deg, #2980b9, var(--primary-color)) !important;
}

.register-button:active {
  transform: translateY(0) !important;
}

/* 切换模式样式 */
.switch-mode {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
  width: 80%;
  margin-left: 10%;
  padding-bottom: 20px;
}

.divider {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(52, 152, 219, 0.2), transparent);
}

.switch-text {
  padding: 0 15px;
  color: var(--text-secondary);
  font-size: 14px;
}

.switch-text a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  position: relative;
}

.switch-text a:hover {
  color: var(--accent-color);
}

.switch-text a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background: var(--accent-color);
  transition: width 0.3s;
}

.switch-text a:hover::after {
  width: 100%;
}

/* 修复ivu样式干扰 */
.form-item >>> .ivu-form-item-content {
  position: relative;
}

.form-item >>> .ivu-input-wrapper {
  position: relative;
}

.form-item >>> .ivu-input-suffix {
  display: none !important;
}

/* 动画效果 */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 107, 53, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 107, 53, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 53, 0);
  }
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .record {
    width: 90%;
    max-width: 400px;
  }

  .login-form,
  .register-form {
    margin-left: 5%;
    width: 90%;
  }

  .login-button,
  .register-button {
    width: 90%;
    margin-left: 5%;
  }

  .global-capslock-warning {
    top: 10px;
    right: 10px;
    left: 10px;
  }

  .warning-content {
    justify-content: center;
  }

  .eye-icon-container {
    right: 8px;
    width: 24px;
    height: 24px;
  }

  .eye-icon {
    font-size: 16px !important;
  }

  .password-input {
    padding-right: 35px !important;
  }
}

/* 认证页统一白蓝主题 */
.auth-page {
  --auth-blue: #2d6cdf;
  --auth-blue-dark: #1f4fa8;
  --auth-blue-soft: #edf4ff;
  --auth-navy: #172b4d;
  --auth-muted: #71809a;
  --auth-border: #d8e3f1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: var(--app-height, 100vh);
  min-height: 100dvh;
  padding: 32px 24px;
  overflow: auto;
  color: var(--auth-navy);
  background: #eef4fc url('../assets/loginPageDefBg.jpg') center / cover no-repeat;
}

.auth-page::before {
  position: fixed;
  inset: 0;
  z-index: 0;
  content: '';
  pointer-events: none;
  background: rgba(238, 244, 252, 0.46);
}

.auth-shell {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(250px, 1fr) minmax(380px, 420px);
  gap: clamp(42px, 7vw, 96px);
  align-items: center;
  width: min(100%, 900px);
}

.auth-brand {
  padding: 16px 0;
  color: var(--auth-navy);
}

.brand-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 22px;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  background: var(--auth-blue);
  border-radius: 8px;
  box-shadow: 0 12px 26px rgba(45, 108, 223, 0.22);
}

.brand-kicker,
.eyebrow {
  color: var(--auth-blue);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.auth-brand h1 {
  margin: 12px 0 14px;
  color: var(--auth-navy);
  font-size: 38px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.auth-brand p {
  max-width: 260px;
  margin: 0;
  color: var(--auth-muted);
  font-size: 15px;
  line-height: 1.8;
}

.brand-line {
  width: 44px;
  height: 3px;
  margin: 28px 0 12px;
  background: var(--auth-blue);
  border-radius: 2px;
}

.auth-brand > span:last-child {
  color: #8a98ad;
  font-size: 12px;
  letter-spacing: 0.08em;
}

.auth-panel {
  position: relative;
  width: 100%;
  min-height: 500px;
  padding: 42px 40px 26px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(216, 227, 241, 0.92);
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(38, 73, 123, 0.14);
}

.auth-panel::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  content: '';
  background: var(--auth-blue);
}

.auth-content {
  width: 100%;
}

.title-section {
  padding-top: 0;
  margin-bottom: 27px;
  text-align: left;
}

.page-title {
  display: block;
  margin: 10px 0 8px;
  color: var(--auth-navy);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0;
  text-shadow: none;
}

.page-title::after {
  display: none;
}

.subtitle {
  color: var(--auth-muted);
  font-size: 13px;
  letter-spacing: 0;
}

.auth-form {
  width: 100%;
  margin: 0;
}

.field {
  margin-bottom: 17px;
}

.field-label {
  display: block;
  margin-bottom: 8px;
  color: var(--auth-navy);
  font-size: 13px;
  font-weight: 600;
}

.auth-form >>> .ivu-form-item {
  margin-bottom: 0 !important;
}

.auth-form >>> .ivu-form-item-content,
.auth-form >>> .ivu-input-wrapper {
  width: 100%;
}

.auth-input >>> .ivu-input {
  width: 100%;
  height: 46px;
  padding-right: 14px;
  color: var(--auth-navy);
  font-size: 14px;
  background: #fff;
  border: 1px solid var(--auth-border);
  border-radius: 6px;
  box-shadow: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.auth-input >>> .ivu-input:hover {
  border-color: #9bb9e9;
}

.auth-input >>> .ivu-input:focus {
  border-color: var(--auth-blue);
  box-shadow: 0 0 0 3px rgba(45, 108, 223, 0.12);
}

.auth-input >>> .ivu-input::placeholder {
  color: #a4b0c1;
}

.auth-input >>> .ivu-input-prefix {
  left: 13px;
  color: #7793bc;
}

.auth-input >>> .ivu-input-prefix i {
  color: #7793bc;
  font-size: 17px;
}

.auth-input >>> .ivu-input-with-prefix {
  padding-left: 40px;
}

.password-input-wrapper {
  position: relative;
  width: 100%;
}

.password-input {
  padding-right: 0 !important;
}

.password-input >>> .ivu-input {
  padding-right: 46px;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 8px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #7793bc;
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: 4px;
  transform: translateY(-50%);
}

.password-toggle:hover,
.password-toggle:focus {
  color: var(--auth-blue);
  background: var(--auth-blue-soft);
  outline: none;
}

.password-toggle i {
  font-size: 18px;
}

.capslock-warning {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 30px;
  margin: -3px 0 13px;
  padding: 7px 10px;
  color: #946200;
  font-size: 12px;
  background: #fff8e7;
  border: 1px solid #f0d99a;
  border-radius: 4px;
  animation: none;
}

.capslock-warning i {
  color: #c58a11;
}

.auth-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 46px;
  margin-top: 8px;
  padding: 0 16px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.12em;
  cursor: pointer;
  background: var(--auth-blue);
  border: 1px solid var(--auth-blue);
  border-radius: 6px;
  box-shadow: 0 8px 18px rgba(45, 108, 223, 0.2);
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.auth-submit:hover:not(:disabled) {
  background: var(--auth-blue-dark);
  box-shadow: 0 10px 22px rgba(45, 108, 223, 0.28);
  transform: translateY(-1px);
}

.auth-submit:active:not(:disabled) {
  box-shadow: 0 4px 10px rgba(45, 108, 223, 0.2);
  transform: translateY(0);
}

.auth-submit:disabled {
  cursor: wait;
  opacity: 0.68;
}

.button-spinner {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: auth-spin 0.7s linear infinite;
}

.switch-mode {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 25px 0 0;
  padding-bottom: 0;
}

.divider {
  height: 1px;
  background: #e5edf7;
}

.switch-text {
  flex: 0 0 auto;
  padding: 0 13px;
  color: var(--auth-muted);
  font-size: 12px;
}

.switch-link {
  padding: 0;
  color: var(--auth-blue);
  font-size: inherit;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.switch-link:hover,
.switch-link:focus {
  color: var(--auth-blue-dark);
  text-decoration: underline;
  outline: none;
}

.global-capslock-warning {
  position: fixed;
  top: max(16px, env(safe-area-inset-top));
  right: 16px;
  z-index: 10;
  cursor: pointer;
  animation: slideIn 0.25s ease-out;
}

.warning-content {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 10px 13px;
  color: #946200;
  font-size: 12px;
  font-weight: 600;
  background: #fff8e7;
  border: 1px solid #f0d99a;
  border-radius: 5px;
  box-shadow: 0 8px 20px rgba(79, 61, 15, 0.12);
}

.global-warning-icon {
  margin-right: 7px;
  color: #c58a11;
  font-size: 16px;
}

.close-icon {
  margin-left: 8px;
  color: #946200;
  font-size: 15px;
}

.auth-switch-enter-active,
.auth-switch-leave-active {
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.auth-switch-enter,
.auth-switch-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

@keyframes auth-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .auth-page {
    align-items: flex-start;
    padding: max(18px, env(safe-area-inset-top)) 12px max(18px, env(safe-area-inset-bottom));
  }

  .auth-shell {
    display: block;
    width: min(100%, 440px);
  }

  .auth-brand {
    padding: 4px 4px 18px;
    text-align: center;
  }

  .brand-mark {
    width: 44px;
    height: 44px;
    margin: 0 auto 12px;
    font-size: 20px;
  }

  .auth-brand h1 {
    margin: 7px 0 5px;
    font-size: 26px;
  }

  .auth-brand p,
  .brand-line,
  .auth-brand > span:last-child {
    display: none;
  }

  .auth-panel {
    min-height: 0;
    padding: 30px 18px 21px;
  }

  .title-section {
    margin-bottom: 24px;
  }

  .page-title {
    font-size: 24px;
  }

  .auth-input >>> .ivu-input {
    height: 44px;
  }

  .auth-submit {
    height: 45px;
  }

  .global-capslock-warning {
    top: max(10px, env(safe-area-inset-top));
    right: 12px;
    left: 12px;
  }

  .warning-content {
    justify-content: center;
  }
}

@media (max-width: 360px) {
  .auth-page {
    padding-right: 10px;
    padding-left: 10px;
  }

  .auth-panel {
    padding-right: 15px;
    padding-left: 15px;
  }

  .field {
    margin-bottom: 14px;
  }

  .title-section {
    margin-bottom: 19px;
  }
}

@media (max-width: 768px) and (max-height: 650px) {
  .auth-page {
    padding-top: max(10px, env(safe-area-inset-top));
  }

  .auth-brand {
    padding-bottom: 10px;
  }

  .brand-mark {
    margin-bottom: 7px;
  }

  .auth-panel {
    padding-top: 23px;
  }

  .field {
    margin-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue